var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg021Date(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H17C17 2.44772 16.5523 2 16 2C15.4477 2 15 2.44772 15 3H9C9 2.44772 8.55228 2 8 2C7.44772 2 7 2.44772 7 3H6C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21ZM5 6C5 5.44772 5.44772 5 6 5H7V6C7 6.55228 7.44772 7 8 7C8.55228 7 9 6.55228 9 6V5H15V6C15 6.55228 15.4477 7 16 7C16.5523 7 17 6.55228 17 6V5H18C18.5523 5 19 5.44772 19 6V9H5V6ZM5 11H19V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V11Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg021Date);
export default __webpack_public_path__ + "static/media/021-date.bedf85b555c19e9b27713ef273b7b0f5.svg";
export { ForwardRef as ReactComponent };